import { render } from "./OpenChannel.vue?vue&type=template&id=126f2e5e&ts=true"
import script from "./OpenChannel.vue?vue&type=script&lang=ts"
export * from "./OpenChannel.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/angelleague-front/angelleague-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__